<template>
<div class="custom-color-popover-box">
  <el-popover
    placement="bottom"
    popper-class="custom-color-popover"
    ref="popover"
    trigger="click">
    <div class="color-box">
      <div v-for="(item) in colorList" :key="item.color" :style="{'background-color':item.bg,'border-color':currentValue.color === item.color ? item.color : ''}" @click="selectColor(item)">
        <i class="icon iconfont iconicon_selected" v-if="currentValue.color === item.color" :style="{color: item.color}"></i>
      </div>
    </div>
    <div class="select-color-box" slot="reference" :style="{'border-color': getColorItem(currentValue.color).color,'background-color':getColorItem(currentValue.color).bg}"></div>
  </el-popover>
</div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      colorList: [{
        color: '#6D6D6D',
        bg:'#DADADA'
      },{
        color: '#986F33FF',
        bg:'#EDDFCDFF'
      },{
        color: '#E97422FF',
        bg:'#FFE5D4FF'
      },{
        color: '#AD8E11FF',
        bg:'#FAF2D3FF'
      },{
        color: '#467119FF',
        bg:'#DFEDD1FF'
      },{
        color: '#0E6D6DFF',
        bg:'#CCE7E7FF'
      },{
        color: '#227FC4FF',
        bg:'#C8E3FBFF'
      },{
        color: '#0062A0FF',
        bg:'#A1D5F6FF'
      },{
        color: '#3B4DB8FF',
        bg:'#E7EBFFFF'
      },{
        color: '#984DCDFF',
        bg:'#DCC3EEFF'
      },{
        color: '#CA5386FF',
        bg:'#F9D5E5FF'
      },{
        color: '#CA4437FF',
        bg:'#FFE9E7FF'
      }]
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    selectColor(item) {
      this.currentValue.color = item.color
      this.currentValue.bg = item.bg
      this.$nextTick(() => {
        this.$forceUpdate()
        this.$refs.popover.doClose()
      })
    },
    getColorItem(color) {
      if (!color) {
        return {}
      }
      return this.colorList.find(res => res.color === color) || {}
    },
  }
}
</script>
<style lang="scss">
.custom-color-popover {
  .color-box{
    width: 184px;
    padding:16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    >div{
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 4px;
      margin:4px;
      border:1px solid rgba(255,255,255,0);
      cursor: pointer;
      i{
        font-size: 18px;
      }
    }
  }

}
.custom-color-popover-box {
  .select-color-box{
    width: 18px;
    height: 18px;
    border:1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    box-sizing: border-box;
    cursor: pointer;
  }
}
</style>
